<template>
  <div v-if="items && items.length" class="products-col">
    <h2 class="products-col__title" v-if="title">{{ title }}</h2>
    <div class="products-col__list">
      <ProductCardComponent v-for="(item, i) in items" :key="i" :data="item" />
    </div>
  </div>
</template>

<script>
import ProductCardComponent from "components/product/ProductCardComponent.vue";

export default {
  name: "ProductsColComponent",
  components: { ProductCardComponent },
  props: {
    title: String,
    items: Array,
  },
};
</script>

<style lang="stylus">
.products-col {
  &:first-child &__list,
  &:last-child &__list {
    &:after {
      content: "";
      display: block;
      height: 100%;
      width: 1px;
      position: absolute;
      background: var(--gray);
      right: -22px;
      top: 0;
      +below(1200px) {
        display none
      }
    }
  }

  &:last-child  &__list {
    &:after {
      left: -22px;
      right: 0;
    }
  }

  &__title {
    font-weight: 700;
    font-size: 1.5em
    line-height: 150%;
  }

  &__list {
    position relative
    display grid
    grid-template-columns 1fr 1fr
    grid-gap 20px
    +below(1200px) {
      grid-template-columns: repeat(auto-fit, 210px);
      grid-auto-columns: 210px;
      grid-auto-flow: column;
      overflow-x auto
			scrollbar-width: none
      margin 0 calc(-1 * var(--sides_padding))
      padding 0 var(--sides_padding)
      grid-gap 30px
    }
    +below(580px) {
      grid-gap 20px
      grid-template-columns: repeat(auto-fit, 204px);
      grid-auto-columns: 204px;
    }
  }
}
</style>
